export const css = {
    header: 'S1ehgCMq',
    progressContainer: 'v2nIpKKE',
    list: 'aNdUBT2b',
    accordion: 'zY7jaoUv',
    accordionTitleContainer: '_8riNIyKo',
    accordionTitle: 'MjR8hfPF',
    accordionGroupNumber: 'O7so27UQ',
    accordionGroupTitle: '_6vin3xRW',
    accordionContentRow: 'RVfTNk4b',
    readingTime: 'nDGKgLdh',
    lessonTitleRow: 'wPifk-5k',
    actionButton: 'A-ZkoLZn',
    progressLabel: '_06Pe0SXG',
    ' _key': 'mc-widgets/topics'
};
export default css;
